import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  IconButton,
  Stack,
  Tooltip,
} from "@mui/material";
import { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useContext, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { ContextOperation } from "../../context/OperationContext";
import { useAgGridCustomDatasource } from "../../hooks/useAgGridCustomDatasource";
import useOperationTranslation from "../../hooks/useOperationTranslation";
import useSnackbar from "../../hooks/useSnackbar";
import useTenant from "../../hooks/useTenant";
import FormInput from "../common/FormInput";
import GenericFilterBox from "../common/GenericFilterBox";
import { nameof } from "../common/ObjectUtils";
import { MissingEquipmentTypes } from "./Types";
import dayjs from "dayjs";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import MissingEquipmentServer from "./service/MissingEquipmentService";
import { customTheme } from "../../../../config/theme/MuiTheme";
import MonySymbolsComponets from "../common/MonySymbolsComponents";
import { saveFileFromResponse } from "../../utils";
import { AutoCompleteOption } from "../common/AutoComplete";
import { useSearchParams } from "react-router-dom";
import DamageFormService from "../damageFormList/service/DamageFormService";
import { useNavigate } from "react-router-dom";
import * as Mui from "@mui/material";
import * as MuiIcons from "@mui/icons-material";
import { ContextDamageForm } from "../damageFormList/DamageFormContext";
import AgGridOperationTable from "../common/AgGridOperationTable";

export default function MissingEquipmetTable() {
  const gridEquipmentsRef = useRef<AgGridReact>(null);
  const t = useOperationTranslation();
  const { setLoading } = useContext(ContextOperation);
  const { tenant } = useContext(ContextOperation);
  const [equipmentList, setEquipmentList] = useState<AutoCompleteOption[]>([]);
  const { tenantOptions: options } = useTenant();
  const [queryParams] = useSearchParams();
  const form = useForm<MissingEquipmentTypes.MissingEquipmentFilter>({
    defaultValues: {
      formCode: queryParams.get("formCode") || undefined,
      present: 'all',
    },
  });

  const navigate = useNavigate();

  const [
    damagePriceListDataSource,
    totalmissingEquipment,
    updateDatasourceDamage,
  ] = useAgGridCustomDatasource(
    MissingEquipmentServer.get.getAllEquipment,
    [tenant, { ...form.getValues(), present: form.getValues('present') === 'all' ? undefined : form.getValues('present') }],
    [tenant, form.formState.submitCount]
  );

  const exportFilters = {
    ...form.getValues(),
    present: form.getValues('present') === 'all' ? undefined : form.getValues('present'),
  };
  const damageFormContext = useContext(ContextDamageForm);
  const onSubmit = () => {};
  const handleDownloadTemplate = () => {
    setLoading(true);
    MissingEquipmentServer.get
      .export(tenant, exportFilters)
      .then((response) => {
        saveFileFromResponse(response);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        snackbar.show("error", t("missingEquipment.errors.actionError"));
      });
  };
  useEffect(() => {
    gridEquipmentsRef.current?.api.deselectAll();
  }, [form.formState.submitCount]);

  useEffect(() => {
    getEquipmentList();
  }, [tenant]);

  const getEquipmentList = () => {
    MissingEquipmentServer.get.getEquipment(tenant).then((response) => {
      setEquipmentList(
        response.map((eqp: any) => ({
          value: eqp.code,
          label: `${eqp.label}`,
        }))
      );
    });
  };

  const isDisabled = () => {
    const values = form.getValues();
    if (Object.keys(values).length !== 1 || options.length > 1) {
      return Object.values(values).every(
          (x) => x === null || x === undefined || x === ""
      );
    }
    return true;
  };

  const showBackToForm = () => {
    if (
      queryParams.get("formCode") === undefined ||
      queryParams.get("tenant") === undefined ||
      queryParams.get("formCode") === null ||
      queryParams.get("tenant") === null ||
      queryParams.get("formCode") === "" ||
      queryParams.get("tenant") === ""
    ) {
      return false;
    } else {
      return true;
    }
  };

  const onBackToFormDetails = () => {
    if (
      queryParams.get("formCode") === undefined ||
      queryParams.get("tenant") === undefined ||
      queryParams.get("formCode") === null ||
      queryParams.get("tenant") === null ||
      queryParams.get("formCode") === "" ||
      queryParams.get("tenant") === ""
    ) {
      snackbar.show("warning", t("damageList.error.noformselected"));
      return;
    } else {
      var formCode = queryParams.get("formCode") || "";
      var tenant = queryParams.get("tenant") || "";

      DamageFormService.details.generalInfo.get
        .byCode(formCode, tenant)
        .then((response) => {
          const id = response;

          damageFormContext.setGeneralInfo(undefined);
          damageFormContext.setTask1(undefined);
          damageFormContext.setTask2(undefined);
          damageFormContext.setTask3(undefined);

          if (id === null || id === undefined) {
            snackbar.show("error", t("damageList.error.noformforcode"));
            return;
          } else {
            navigate(`/operation/damages/forms/details/${id}`);
          }
        })
        .catch((error: any) => {
          snackbar.show("error", "No damage form found for selected code!");
          return;
        });
    }
  };

  const equipmentColumns: ColDef[] = [
    {
      field: nameof<MissingEquipmentTypes.MissingEquipment>("formCode"),
      headerName: t("missingEquipment.fields.formCode"),
      flex: 1,
    },
    {
      field: nameof<MissingEquipmentTypes.MissingEquipment>("descr"),
      headerName: t("missingEquipment.fields.equipment"),
      flex: 1,
    },
    {
      field: nameof<MissingEquipmentTypes.MissingEquipment>("price"),
      headerName: t("missingEquipment.fields.price"),
      flex: 1,
      cellRenderer: (params: any) => {
        return (
          <MonySymbolsComponets
            symbolText={params.data?.price}
            symbols={params.data?.currency}
          />
        );
      },
    },

    {
      field: nameof<MissingEquipmentTypes.MissingEquipment>("createDate"),
      headerName: t("missingEquipment.fields.createData"),
      flex: 1,
      cellRenderer: (params: any) => {
        return <>{dayjs(`${params.data.createDate}`).format("DD/MM/YYYY")}</>;
      },
    },
    {
      field: nameof<MissingEquipmentTypes.MissingEquipment>("present"),
      headerName: t("missingEquipment.fields.present"),
      flex: 1,
      cellRenderer: (params: any) => {
        return <>{params.data.present === false ? (
          <IconButton size="small">
            <MuiIcons.Close color="error" />
          </IconButton>
        ) : (
          <IconButton size="small">
            <MuiIcons.Check color="success" />
          </IconButton>
        )}</>;
      },
      valueFormatter: (params) => {
        if (typeof params.data?.present === "boolean") {
          return params.data.present
            ? t("missingEquipment.fields.present")
            : t("missingEquipment.fields.notPresent");
        }
        return "";
      },
    },
  ];
  const snackbar = useSnackbar();

  return (
    <Box>
      <>
        <form id="misssing-equipment" onSubmit={form.handleSubmit(onSubmit)}>
          <GenericFilterBox
            formId="misssing-equipment"
            disableResetButton={isDisabled()}
            onReset={() => {
              form.reset();
            }}
          >
            <FormInput
              type="text"
              label={t("missingEquipment.fields.formCode")}
              name={nameof<MissingEquipmentTypes.MissingEquipmentFilter>(
                "formCode"
              )}
              formInstance={form}
              fullWidth
            />
            <FormInput
              type="select"
              options={equipmentList}
              label={t("missingEquipment.fields.equipment")}
              name={nameof<MissingEquipmentTypes.MissingEquipmentFilter>(
                "equipmentCode"
              )}
              value={form.watch("equipmentCode")}
              onChange={(value) => {
                form.setValue(
                  nameof<MissingEquipmentTypes.MissingEquipmentFilter>(
                    "equipmentCode"
                  ),
                  value
                );
              }}
              fullWidth
            />

            <FormInput
              type="text"
              label={t("missingEquipment.fields.plate")}
              name={nameof<MissingEquipmentTypes.MissingEquipmentFilter>(
                "plate"
              )}
              formInstance={form}
              fullWidth
            />
            <FormInput
              type="text"
              label={t("missingEquipment.fields.vin")}
              name={nameof<MissingEquipmentTypes.MissingEquipmentFilter>("vin")}
              formInstance={form}
              fullWidth
            />
            <FormInput
              type="select"
              options={[
                { value: "all", label: t("missingEquipment.fields.all") },
                { value: true, label: t("missingEquipment.fields.present") },
                { value: false, label: t("missingEquipment.fields.notPresent") },
              ]}
              label={t("missingEquipment.fields.equipmentStatus")}
              name={nameof<MissingEquipmentTypes.MissingEquipmentFilter>("present")}
              formInstance={form}
              fullWidth
            />
          </GenericFilterBox>
        </form>

        <Card>
          <CardContent>
            {/* <Box
                    sx={{ backgroundColor: "white",border:' 1px solid #dbe4e9',
                    borderRadius: '2px',padding:"9px 1px 3px 2px"}}
                  > */}
            <Grid
              container
              spacing={2}
              alignItems="center"
              alignContent="center"
              direction="row"
            >
              <Grid item xs={6}>
                {showBackToForm() && (
                  <Mui.CardHeader
                    title={
                      <Mui.Typography variant="h5">
                        {t("damageList.backtoForm")}
                      </Mui.Typography>
                    }
                    avatar={
                      <Mui.IconButton onClick={() => onBackToFormDetails()}>
                        <MuiIcons.ArrowBack />
                      </Mui.IconButton>
                    }
                  />
                )}
              </Grid>
              <Grid item xs={5.9}>
                <Box
                  sx={{
                    justifyContent: "flex-end",
                    display: "flex",
                    gap: "10px",
                  }}
                >
                  <Stack direction="row" alignItems="center">
                    <Button
                      variant="text"
                      size="icon"
                      disabled={totalmissingEquipment ? false : true}
                      onClick={handleDownloadTemplate}
                      color="accent"
                    >
                      <Tooltip title={t("tooltipTitle.download")}>
                        <FileDownloadIcon />
                      </Tooltip>
                    </Button>
                  </Stack>
                </Box>
              </Grid>
            </Grid>
            {/* </Box> */}

            <Grid>
              <Grid item sx={{ whiteSpace: "pre-wrap" }}>
                <AgGridOperationTable
                  rowStyle={{ width: "250%" }}
                  columnDefs={equipmentColumns}
                  serverSideDatasource={damagePriceListDataSource}
                  rowModelType="serverSide"
                  serverSideInfiniteScroll={true}
                  cacheBlockSize={10}
                  rowSelection="single"
                  totalElements={totalmissingEquipment}
                  emptyState={{
                    title:t("missingEquipment.noData.title"),
                    content:t("missingEquipment.noData.body")
                  }}
                />

              </Grid>
            </Grid>

            {/* </Box> */}
          </CardContent>
        </Card>
      </>
    </Box>
  );
}
